export default __webpack_public_path__ + "static/media/1.a4a5845b.png";